// extracted by mini-css-extract-plugin
module.exports = {"label":"LogsComponent_label__2OsET","maxHeight200px":"LogsComponent_maxHeight200px__29g4N","maxWidth9Rem":"LogsComponent_maxWidth9Rem__AM4n9"};